"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
var _cccisdFormik = require("cccisd-formik");
var _helpers = require("../../helpers");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TabName = function TabName() {
  return /*#__PURE__*/_react["default"].createElement("fieldset", {
    className: _style["default"].fieldset
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "courseDescription.tabName",
    component: _cccisdFormik.CccisdInput,
    label: /*#__PURE__*/_react["default"].createElement(_helpers.LabelWithTooltip, {
      label: /*#__PURE__*/_react["default"].createElement("h4", {
        className: _style["default"].fieldsetHeading,
        style: {
          display: 'inline-block'
        }
      }, "Tab Name"),
      tooltip: "The text for Course Overview in the tab bar"
    })
  }));
};
var _default = exports["default"] = TabName;